
export interface QRCode {
  id?: number | string;
  barId?: string;
  qrData?: string;
  type?: string;
  tableNumber?: string | number;
  isActive?: boolean;
  scanCount?: number;
  lastScannedAt?: string | Date;
  createdAt?: string | Date;
  updatedAt?: string | Date;
  description?: string;
  qrImageUrl?: string;
  createdBy?: number;
  expiresAt?: string | Date | null;
  maxScans?: number;
  expired?: boolean;
  // Additional fields for component display
  lastScanned?: string | Date;
  url?: string;
  name?: string;
}
